import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ChartLayoutModeService {
    public subscriber: Subject<string> = new Subject<string>();
    
    
    
    
    
}